import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGetSubscriptionBenefits } from "../actions/get-benefits";
import { CompanyBenefitDto } from "../types/benefits.types";
import { setSubscriptions } from "./benefits.slice";

export const fetchBenefits = createAsyncThunk<CompanyBenefitDto[]>("benefits/fetchBenefits", async (_, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await apiGetSubscriptionBenefits();
    const state: any = getState();
    const currentSubscription = state.userState.subscription;

    dispatch(
      setSubscriptions({
        ...currentSubscription,
        subscriptions: response.subscriptions,
      }),
    );

    const mergedBenefits: CompanyBenefitDto[] = (response.benefits ?? []).map((item: any) => ({
      id: item.CompanyBenefits?.id ?? item.id,
      benefitId: item.id,
      usageCount: item.CompanyBenefits?.usageCount ?? 0,
      expDate: item.CompanyBenefits?.expDate,
      isDeleted: false,
      createdAt: item.CompanyBenefits?.createdAt ?? item.createdAt,
      updatedAt: item.updatedAt,
      benefit: {
        id: item.id,
        name: item.name,
        description: item.description,
        type: item.type,
        config: item.config,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      },
    }));

    return mergedBenefits;
  } catch (e: any) {
    return rejectWithValue(e?.message ?? "Failed to fetch benefits");
  }
});
